"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var FactoryResetDialog_1 = __importDefault(require("./FactoryResetDialog"));
var ResetComponent = function ResetComponent(_ref) {
  var onFactoryReset = _ref.onFactoryReset,
    resetButtonText = _ref.resetButtonText;
  var _ref2 = (0, react_1.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    dialogOpen = _ref3[0],
    setDialogOpen = _ref3[1];
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(material_1.Button, {
    "data-testid": "fatal-error",
    color: "primary",
    variant: "contained",
    onClick: function onClick() {
      return setDialogOpen(true);
    }
  }, resetButtonText), react_1.default.createElement(FactoryResetDialog_1.default, {
    onClose: function onClose() {
      return setDialogOpen(false);
    },
    open: dialogOpen,
    onFactoryReset: onFactoryReset
  }));
};
var FatalErrorDialog = function FatalErrorDialog(_ref4) {
  var componentStack = _ref4.componentStack,
    _ref4$error = _ref4.error,
    error = _ref4$error === void 0 ? 'No error message provided' : _ref4$error,
    onFactoryReset = _ref4.onFactoryReset,
    _ref4$resetButtonText = _ref4.resetButtonText,
    resetButtonText = _ref4$resetButtonText === void 0 ? 'Factory Reset' : _ref4$resetButtonText;
  return react_1.default.createElement(material_1.Dialog, {
    open: true
  }, react_1.default.createElement(material_1.DialogTitle, {
    style: {
      background: '#e88'
    }
  }, "Fatal error"), react_1.default.createElement(material_1.DialogContent, null, react_1.default.createElement("pre", null, "".concat(error), componentStack)), react_1.default.createElement(material_1.DialogActions, null, react_1.default.createElement(material_1.Button, {
    color: "secondary",
    variant: "contained",
    onClick: function onClick() {
      return window.location.reload();
    }
  }, "Refresh"), react_1.default.createElement(ResetComponent, {
    onFactoryReset: onFactoryReset,
    resetButtonText: resetButtonText
  })));
};
exports.default = FatalErrorDialog;